
















import Vue, { PropType } from 'vue'

import { EventService } from '../../base/services/EventService'
import { Widget } from '../widgets/base'
import ElementTreePanelRowControls from './ElementTreePanelRowControls.vue'

export default Vue.extend({
  components: {
    ElementTreePanelRow: () => import('./ElementTreePanelRow.vue'),
    ElementTreePanelRowControls
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true,
      default: {}
    },
    selectedWidgetUUID: {
      type: Array,
      required: false,
      default: []
    }
  },
  computed: {
    isWidgetSelected() {
      return this.selectedWidgetUUID.indexOf(this.widget.wbUUID) > -1
    },
    widgetHasChildren() {
      return !!this.widget.rows
    },
    widgetIcon() {
      return this.widget.icon || 'CardTextOutline'
    }
  },
  data() {
    return {
      isHovering: false
    }
  },
  methods: {
    onHover() {
      this.isHovering = true
    },
    onUnhover() {
      this.isHovering = false
    },
    onSelectWidget() {
      EventService.$emit('widget-select-by-uuid', this.widget.wbUUID)
    },
    onHighlightWidget() {
      EventService.$emit('widget-highlight-by-uuid', this.widget.wbUUID)
    },
    onUnhighlightWidget(wbUUID) {
      EventService.$emit('widget-highlight-by-uuid', null)
    }
  }
})
